export default __webpack_public_path__ + "locales/ko-KR/Common.json?hash=db5f62b69c3180ac3fb885cf2275b32d";